import React, { useState, useEffect } from "react";
import { Box, TextField, Chip } from "@mui/material";

interface SearchProps {
  onSearch: (terms: string[]) => void;
}

const Search: React.FC<SearchProps> = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerms, setSearchTerms] = useState<string[]>([]);

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && searchTerm.trim() !== "") {
      setSearchTerms([...searchTerms, searchTerm.trim()]);
      setSearchTerm("");
    }
  };

  const handleDelete = (termToDelete: string) => {
    const updatedTerms = searchTerms.filter((term) => term !== termToDelete);
    setSearchTerms(updatedTerms);
    onSearch(updatedTerms);
  };

  useEffect(() => {
    onSearch(searchTerms);
  }, [searchTerms, onSearch]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" my={2}>
      <Box display="flex" justifyContent="center" alignItems="center">
        <TextField
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Search by NUS Course Code/Title 📚"
          style={{ marginRight: 8, width: "300px" }}
        />
      </Box>

      <Box display="flex" flexWrap="wrap" justifyContent="center" mt={2}>
        {searchTerms.map((term) => (
          <Chip
            key={term}
            label={term}
            onDelete={() => handleDelete(term)}
            style={{ margin: 4 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Search;
